import { render } from "./ChooseFlatsBanner.vue?vue&type=template&id=1c79d134&scoped=true"
import script from "./ChooseFlatsBanner.vue?vue&type=script&lang=js"
export * from "./ChooseFlatsBanner.vue?vue&type=script&lang=js"

import "./ChooseFlatsBanner.vue?vue&type=style&index=0&id=1c79d134&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c79d134"]])

export default __exports__